import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronRight } from 'lucide-react';

const MegaMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('trademark');

  const menuData = [
    {
      id: 'trademark',
      title: 'Trademark Services',
      items: [
        { 
          name: 'Register Your Trademark', 
          path: '/services/trademark-registration',
          desc: 'Secure brand rights with thorough searches and expert registration services.'
        },
        { 
          name: 'Clearance Search Services', 
          path: '/services/trademark-search',
          desc: 'Ensure brand uniqueness with comprehensive clearance searches.'
        },
        { 
          name: 'Trademark Ownership Transfers', 
          path: '/services/trademark-ownership-transfers',
          desc: 'Smoothly transfer trademark ownership with our expert guidance.'
        },
        { 
          name: 'Submission of Statements of Use', 
          path: '/services/statements-of-use',
          desc: 'Compliantly file Statements of Use for active trademark status.'
        },
        { 
          name: 'Support and Response for Trademark Office Actions', 
          path: '/services/trademark-office-actions',
          desc: 'Navigate challenges with strategic responses to trademark office actions.'
        },
        { 
          name: 'Active Monitoring for Trademark infringement', 
          path: '/services/trademark-monitoring',
          desc: 'Vigilantly monitor trademarks to protect against potential infringements.'
        },
        { 
          name: 'File TTAB Petition', 
          path: '/services/ttab-petition',
          desc: 'Trust us to handle your TTAB petition safely and professionally.'
        }
      ]
    },
    {
      id: 'company',
      title: 'Company Formation Services',
      items: [
        { 
          name: 'Limited Liability Company', 
          path: '/services/llc-formation',
          desc: 'Establish your LLC with full legal protection and flexibility.'
        },
        { 
          name: 'C Corporation', 
          path: '/services/c-corporation',
          desc: 'Form a C Corporation for scalability and investor appeal.'
        },
        { 
          name: 'S Corporation', 
          path: '/services/s-corporation',
          desc: 'Benefit from pass-through taxation with S Corporation formation.'
        },
        { 
          name: 'Non-Profit', 
          path: '/services/non-profit-formation',
          desc: 'Create a non-profit organization with proper compliance structure.'
        }
      ]
    },
    {
      id: 'copyright',
      title: 'Copyright Services',
      items: [
        { 
          name: 'Register Your Copyright', 
          path: '/services/copyright-registration',
          desc: 'Protect creative works with official copyright registration.'
        },
        { 
          name: 'Assistance for Your Copyright Enforcement', 
          path: '/services/copyright-enforcement',
          desc: 'Enforce your rights against copyright infringement effectively.'
        },
        { 
          name: 'Copyright Transfers and Licensing Support', 
          path: '/services/copyright-transfers',
          desc: 'Manage copyright transfers and licensing agreements professionally.'
        },
        { 
          name: 'Legal Representation for Your Copyright', 
          path: '/services/copyright-legal',
          desc: 'Expert legal representation for copyright disputes and litigation.'
        },
        { 
          name: 'Management of Your Copyright Portfolio', 
          path: '/services/copyright-portfolio',
          desc: 'Comprehensive management of your entire copyright portfolio.'
        },
        { 
          name: 'Compliance with DMCA Act', 
          path: '/services/dmca-compliance',
          desc: 'Ensure full compliance with Digital Millennium Copyright Act.'
        }
      ]
    },
    {
      id: 'patent',
      title: 'Patent Services',
      items: [
        { 
          name: 'Search for Existing Patent', 
          path: '/services/patent-search',
          desc: 'Comprehensive patent searches to ensure novelty and patentability.'
        },
        { 
          name: 'Support and Response for Patent Office Actions', 
          path: '/services/patent-office-actions',
          desc: 'Expert responses to patent office actions and rejections.'
        },
        { 
          name: 'Application Submission for Patent', 
          path: '/services/patent-application',
          desc: 'Professional patent application preparation and filing services.'
        },
        { 
          name: 'Legal Representation for Patent Protection', 
          path: '/services/patent-legal',
          desc: 'Strategic legal representation for patent protection and enforcement.'
        }
      ]
    },
    {
      id: 'legal',
      title: 'Legal Services',
      items: [
        { 
          name: 'Business Immigration Law', 
          path: '/services/business-immigration',
          desc: 'Navigate business immigration with expert legal guidance.'
        },
        { 
          name: 'Due Diligence Process', 
          path: '/services/due-diligence',
          desc: 'Comprehensive due diligence for business transactions.'
        },
        { 
          name: 'IT & Commercial Law', 
          path: '/services/it-commercial-law',
          desc: 'Specialized legal services for IT and commercial matters.'
        },
        { 
          name: 'Legal Services on Partnerships & LLPs', 
          path: '/services/partnerships-llps',
          desc: 'Expert guidance on partnership and LLP formations.'
        },
        { 
          name: 'Data Protection & Privacy Law', 
          path: '/services/data-protection',
          desc: 'Comprehensive data protection and privacy compliance services.'
        }
      ]
    },
    {
      id: 'corporate',
      title: 'Additional Corporate Services',
      items: [
        { 
          name: 'Amazon Brand Registry in the US', 
          path: '/services/amazon-brand-registry',
          desc: 'Enroll your brand in Amazon Brand Registry for enhanced protection.'
        },
        { 
          name: 'Bookkeeping Service', 
          path: '/services/bookkeeping',
          desc: 'Professional bookkeeping services for accurate financial records.'
        },
        { 
          name: 'Business Formation Services', 
          path: '/services/business-formation',
          desc: 'Complete business formation services for all entity types.'
        },
        { 
          name: 'Certificate of Good Standing', 
          path: '/services/good-standing-certificate',
          desc: 'Obtain certificates of good standing for your business.'
        },
        { 
          name: 'Company Dissolution', 
          path: '/services/company-dissolution',
          desc: 'Professional assistance with company dissolution and closure.'
        },
        { 
          name: 'Company Name Change', 
          path: '/services/company-name-change',
          desc: 'Seamlessly change your company name with legal compliance.'
        },
        { 
          name: 'Company Renewal Services', 
          path: '/services/company-renewal',
          desc: 'Annual renewal services to maintain good standing status.'
        },
        { 
          name: 'Issue Of Shares', 
          path: '/services/issue-shares',
          desc: 'Professional share issuance and stock certificate services.'
        },
        { 
          name: 'Nominee Director & Secretarial Services', 
          path: '/services/nominee-services',
          desc: 'Nominee director and corporate secretarial services.'
        },
        { 
          name: 'Tax Advisory & Filing', 
          path: '/services/tax-advisory',
          desc: 'Comprehensive tax advisory and filing services.'
        },
        { 
          name: 'Transfer of Shares', 
          path: '/services/transfer-shares',
          desc: 'Facilitate smooth transfer of shares with proper documentation.'
        },
        { 
          name: 'CFO Services', 
          path: '/services/cfo-services',
          desc: 'Fractional CFO services for strategic financial management.'
        }
      ]
    }
  ];

  const activeMenuData = menuData.find(m => m.id === activeCategory) || menuData[0];

  return (
    <div 
      className="relative group"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      {/* Services Button */}
      <button className="flex items-center space-x-1 text-white hover:text-amber-400 transition-colors font-medium py-2">
        <span>Services</span>
        <ChevronDown className="h-4 w-4" />
      </button>

      {/* Mega Menu Dropdown - Professional & Readable */}
      <div
        className={`fixed left-1/2 -translate-x-1/2 top-[80px] w-[90vw] max-w-[1100px] bg-white shadow-2xl rounded-lg transition-all duration-300 ${
          isOpen
            ? 'opacity-100 visible translate-y-0'
            : 'opacity-0 invisible -translate-y-4'
        }`}
        style={{ zIndex: 9999 }}
      >
        <div className="px-6 py-5">
          <div className="grid grid-cols-12 gap-6" style={{ height: '360px' }}>
            {/* Left Side - Categories - Scrollable */}
            <div className="col-span-3 border-r border-gray-200 pr-4 overflow-y-auto">
              <ul className="space-y-1">
                {menuData.map((menu) => (
                  <li key={menu.id}>
                    <button
                      onClick={() => setActiveCategory(menu.id)}
                      onMouseEnter={() => setActiveCategory(menu.id)}
                      className={`w-full text-left px-3 py-2.5 rounded-lg transition-all flex items-center justify-between group ${
                        activeCategory === menu.id
                          ? 'bg-slate-100 text-slate-900 font-semibold'
                          : 'text-gray-700 hover:bg-slate-50 hover:text-slate-900'
                      }`}
                    >
                      <span className="text-sm">{menu.title}</span>
                      <ChevronRight className={`h-4 w-4 transition-transform ${
                        activeCategory === menu.id ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
                      }`} />
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Side - Services in 2 Columns - Always Scrollable */}
            <div className="col-span-9 flex flex-col" style={{ height: '360px' }}>
              <h3 className="text-slate-900 font-bold text-base mb-3 pb-2.5 border-b border-gray-200 flex-shrink-0">
                {activeMenuData.title}
              </h3>
              <div className="flex-1 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                <div className="grid grid-cols-2 gap-x-5 gap-y-2">
                  {activeMenuData.items.map((item, idx) => (
                    <Link
                      key={idx}
                      to={item.path}
                      onClick={() => setIsOpen(false)}
                      className="group block"
                    >
                      <div className="flex items-start space-x-2.5 p-2.5 rounded-lg hover:bg-slate-50 transition-all">
                        <ChevronRight className="h-4 w-4 text-amber-500 flex-shrink-0 mt-0.5 group-hover:translate-x-1 transition-transform" />
                        <div>
                          <h4 className="text-slate-900 font-semibold text-sm mb-1 group-hover:text-amber-600 transition-colors leading-tight">
                            {item.name}
                          </h4>
                          <p className="text-gray-600 text-xs leading-relaxed">
                            {item.desc}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
